module.exports = __webpack_public_path__ + "static/media/omelette.1ad4cebe.svg";